import { render } from "./ClassHeader.vue?vue&type=template&id=61c852bd&scoped=true"
import script from "./ClassHeader.vue?vue&type=script&lang=js"
export * from "./ClassHeader.vue?vue&type=script&lang=js"

import "./ClassHeader.vue?vue&type=style&index=0&id=61c852bd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c852bd"]])

export default __exports__